import { render, staticRenderFns } from "./allFund.vue?vue&type=template&id=c0b2b600&scoped=true"
import script from "./allFund.vue?vue&type=script&lang=js"
export * from "./allFund.vue?vue&type=script&lang=js"
import style0 from "./allFund.vue?vue&type=style&index=0&id=c0b2b600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b2b600",
  null
  
)

export default component.exports